export const BRAND = {
  name: "EMB Consulting Group",
  tagline: "Financial Planning · Regular Savings",
  phone: "+52 984 185 9759",
  whatsapp: "+529841859759",
  email: "atención@embconsultingroup.com.mx",
  address: "Playa del Carmen, Quintana Roo · México",
  founded: "2013",
  mdrtMember: true,
  mdrtYear: "2026",
  mdrtLogoColor: "https://customer-assets.emergentagent.com/job_wealth-protection-mx/artifacts/tol2wn9z_2026-MDTR-Member-Logo-Color.png",
  mdrtLogoBlack: "https://customer-assets.emergentagent.com/job_wealth-protection-mx/artifacts/18u3tjuo_2026-MDRT-Member-Logo-Black.png",
  amasfacLogoWhite:
    "https://customer-assets.emergentagent.com/job_wealth-protection-mx/artifacts/6ihwpzry_Logo-AMASFAC-Por-todo-lo-que-nos-une-blanco.png",
  canacintraLogo:
    "https://customer-assets.emergentagent.com/job_wealth-protection-mx/artifacts/qlbqzrbs_canacintralogo.png",
  allianzPromotoria: "559",
  founderCedulaNumber: "C404868",
  logoWhite:
    "https://customer-assets.emergentagent.com/job_d4836b04-f8d9-4e8f-808f-9840ff61c91b/artifacts/jm3k0x7r_Transparente.png",
  logoOriginal:
    "https://customer-assets.emergentagent.com/job_d4836b04-f8d9-4e8f-808f-9840ff61c91b/artifacts/ocq22uy0_Original.png",
};

export const NAV_LINKS = [
  { id: "nosotros", label: "Nosotros" },
  { id: "asesores", label: "Asesores" },
  { id: "unete", label: "Únete" },
  { id: "ciclo-vital", label: "Ciclo Vital" },
  { id: "servicios", label: "Servicios" },
  { id: "socios", label: "Socios" },
  { id: "instrumentos", label: "Instrumentos" },
  { id: "dca", label: "DCA" },
  { id: "aseguradoras", label: "Aseguradoras" },
  { id: "contacto", label: "Contacto" },
];

export const SOCIALS = [
  {
    name: "LinkedIn",
    icon: "Linkedin",
    url: "https://www.linkedin.com/company/emb-consulting-group/",
  },
  {
    name: "Instagram",
    icon: "Instagram",
    url: "https://www.instagram.com/embconsultingroup",
  },
  {
    name: "Facebook",
    icon: "Facebook",
    url: "https://www.facebook.com/share/18wjW4c2dn/",
  },
  {
    name: "X",
    icon: "Twitter",
    url: "https://x.com/embconsultingg",
  },
];

/* -------------------- LOGOS / WORDMARKS --------------------
 * Design decision: instead of mixing inconsistent third-party logo
 * images (which look messy across 14+ brands), we render each
 * institution as an editorial typographic wordmark in the EMB serif.
 * This matches private-banking print aesthetics and keeps the grid
 * visually cohesive. (Per design_guidelines.json logos_grid spec.)
 */

export const FINANCIAL_PARTNERS = [
  {
    name: "Allianz México",
    wordmark: "Allianz",
    relation: "Promotores autorizados",
    detail:
      "Distribución oficial de productos financieros y de protección Allianz, una de las firmas aseguradoras y de gestión de activos más sólidas a nivel global.",
  },
  {
    name: "Skandia",
    wordmark: "Skandia",
    relation: "Clave directa",
    detail:
      "Acceso preferente a productos de inversión, ahorro a largo plazo y planes patrimoniales con uno de los referentes nórdicos de wealth management en México.",
  },
  {
    name: "Dominion Capital Strategies",
    wordmark: "Dominion",
    relation: "Clave directa",
    detail:
      "Estructuras de inversión internacional, multi-divisa y planeación patrimonial para clientes con visión global.",
  },
];

export const INSURERS = [
  { name: "Allianz",        wordmark: "Allianz" },
  { name: "Olé Life",       wordmark: "Olé Life" },
  { name: "HDI",            wordmark: "HDI" },
  { name: "Atlas",          wordmark: "Atlas" },
  { name: "Qualitas",       wordmark: "Qualitas" },
  { name: "Qualitas Salud", wordmark: "Qualitas Salud" },
  { name: "Bx+",            wordmark: "Bx+" },
  { name: "BUPA",           wordmark: "BUPA" },
  { name: "AXA",            wordmark: "AXA" },
  { name: "ANA Seguros",    wordmark: "ANA" },
  { name: "Continental",    wordmark: "Continental" },
];

export const REGULATORS = [
  {
    name: "CNBV",
    wordmark: "CNBV",
    full: "Comisión Nacional Bancaria y de Valores",
    logo: "https://customer-assets.emergentagent.com/job_wealth-protection-mx/artifacts/nwip9tm7_Logo_CNBV.png",
  },
  {
    name: "CNSF",
    wordmark: "CNSF",
    full: "Comisión Nacional de Seguros y Fianzas",
    logo: "https://customer-assets.emergentagent.com/job_wealth-protection-mx/artifacts/piz74owt_ICON-CNSF-BLANCO.png",
    invertOnLight: true,
  },
  {
    name: "CONDUSEF",
    wordmark: "CONDUSEF",
    full: "Comisión Nacional para la Protección y Defensa de los Usuarios de Servicios Financieros",
    logo: "https://customer-assets.emergentagent.com/job_wealth-protection-mx/artifacts/fpqvidvc_condusef2.png",
    invertOnLight: true,
  },
];

/* -------------------- ADVISORS -------------------- */
export const FOUNDER = {
  name: "Marco S. Equis",
  role: "Fundador & Director General",
  cedula: "Cédula B · CNSF",
  cedulaNumber: "C404868",
  photo:
    "https://customer-assets.emergentagent.com/job_wealth-protection-mx/artifacts/zep6tch8_99d7cc71-4155-456d-a454-c3cd33181ede.JPG",
  bio: "Fundó EMB Consulting Group en 2013 en Playa del Carmen, Quintana Roo. En febrero de 2024 la firma recibió la promotoría oficial de Allianz México (Promotoría 559), consolidando una década de trabajo asesorando familias y empresarios en finanzas personales, ahorro, inversión y protección patrimonial. Miembro activo de la Million Dollar Round Table (MDRT) y de AMASFAC (Asociación Mexicana de Agentes de Seguros y Fianzas) — los dos referentes de excelencia ética y profesional en la asesoría financiera.",
  credentials: [
    {
      type: "Diplomado",
      name: "Educación Financiera",
      institution: "CONDUSEF",
      detail: "Generación 35",
    },
    {
      type: "Diplomado",
      name: "Seguros",
      institution: "CONDUSEF",
      detail: "Generación 1",
    },
    {
      type: "Diplomado",
      name: "Finanzas Personales",
      institution: "UNAM",
      detail: "Universidad Nacional Autónoma de México",
    },
    {
      type: "Educación continua",
      name: "PEEDTRADE",
      institution: "Avalado por la BMV",
      detail: "Bolsa Mexicana de Valores",
    },
  ],
};

export const ADVISORS = [
  { name: "Marco S. Equis",     cedula: "B",  cedulaNumber: "C404868", role: "Fundador" },
  {
    name: "Judith Marquez",
    cedula: "A",
    cedulaNumber: "V404131",
    photo:
      "https://customer-assets.emergentagent.com/job_wealth-protection-mx/artifacts/z99hgsla_56366313-a0d0-4b7f-9700-1323df6218b7.JPG",
  },
  { name: "Fredy Eguiluz",      cedula: "A1", cedulaNumber: "C398560",
    photo:
      "https://customer-assets.emergentagent.com/job_wealth-protection-mx/artifacts/p70q09ax_d46daeec-cd33-4119-8c41-102955ab3963.JPG",
  },
  {
    name: "Francia Adame",
    cedula: "A1",
    cedulaNumber: "C353378",
    photo:
      "https://customer-assets.emergentagent.com/job_wealth-protection-mx/artifacts/x4fbeyx1_4c01dc2f-aad6-436c-aed8-b18e7e8ba75b.JPG",
  },
  { name: "Ramón Ayala",        cedula: "A1", cedulaNumber: "M369233",
    photo:
      "https://customer-assets.emergentagent.com/job_wealth-protection-mx/artifacts/tuzt89sl_231e2424-4bfd-49b8-a5c5-fd03917b7b68.JPG",
  },
  { name: "Rodrigo Ricardi",    cedula: "B",  cedulaNumber: "G388850",
    photo:
      "https://customer-assets.emergentagent.com/job_wealth-protection-mx/artifacts/asndrcp4_4a8c4935-d0ee-4898-a3b8-80db4fe91afd.JPG",
  },
  { name: "Luis Espinosa",      cedula: "A",  cedulaNumber: "M375337" },
  { name: "Patricia Clemente",  cedula: "A",  cedulaNumber: "V359581",
    photo:
      "https://customer-assets.emergentagent.com/job_wealth-protection-mx/artifacts/3uxnhp0m_c275c2bd-61d4-4f39-8c17-eae8a57b7cbd.JPG",
  },
  { name: "Gerson Zapata",      cedula: "A",  cedulaNumber: "G389116",
    photo:
      "https://customer-assets.emergentagent.com/job_wealth-protection-mx/artifacts/mxihstug_4894aa27-7a6e-46fc-96b3-6f3c90b0611c.JPG",
  },
  { name: "Ana Gamiño",         cedula: "B",  cedulaNumber: "V402404",
    photo:
      "https://customer-assets.emergentagent.com/job_wealth-protection-mx/artifacts/tmmw9xpq_ec709795-ca7d-475d-bedd-b047aa169968.JPG",
  },
  { name: "Christian Bohorquez", cedula: "A1" },
];

/* -------------------- SERVICES & PRODUCTS (merged) --------------------
 * The three pillars (Ahorro & Inversión · Vida & Salud · Patrimoniales)
 * combine the high-level pitch with the concrete catalogue of 13
 * products. One unified section instead of two redundant ones.
 */
export const PILLARS = [
  {
    key: "ahorro-inversion",
    title: "Ahorro & Inversión",
    icon: "TrendingUp",
    description:
      "Construye y multiplica tu patrimonio con instrumentos institucionales. Portafolios indexados, ETF's y planes personales de retiro a través de Skandia, Dominion Capital Strategies y Allianz México — en pesos y multidivisa.",
    items: [
      "Ahorro e Inversión en Fondos Indexados",
      "ETF's",
      "Planes Personales de Retiro (PPR)",
    ],
  },
  {
    key: "vida-salud",
    title: "Vida & Salud",
    icon: "HeartPulse",
    description:
      "Protege a quienes amas y tu salud sin sorpresas. Coberturas de vida, gastos médicos mayores y salud internacional con las principales aseguradoras reguladas en México y sus países de origen.",
    items: [
      "Seguros de Vida Temporales",
      "Gastos Médicos Mayores",
      "Seguros de Salud",
      "Accidentes Personales",
      "Seguros Colectivos",
    ],
  },
  {
    key: "patrimoniales",
    title: "Patrimoniales & Daños",
    icon: "Building2",
    description:
      "Tu patrimonio material — auto, casa, negocio — protegido con las coberturas correctas y la asesoría para usarlas cuando importa. Comparamos a las mejores compañías para encontrar el equilibrio entre costo y cobertura.",
    items: [
      "Seguros de Auto",
      "Seguros Residenciales",
      "Seguros de Comercio",
      "Seguros de Responsabilidad Civil (RC)",
      "Daños",
    ],
  },
];

/* -------------------- LIFE CYCLE (28,000 días) -------------------- */
export const LIFE_PHASES = [
  {
    id: 0,
    range: "0 — 20",
    label: "Primeros 20 años",
    title: "Etapa Formativa",
    color: "#E6D5B8",
    angle: [-90, 0],
    insight: "Capital humano alto · Capital financiero bajo",
    detail:
      "Tu valor está en lo que aprendes. Los ingresos son parciales, los gastos los cubren tus padres. La oportunidad: formar hábitos de ahorro desde temprano.",
    events: [
      "Juegas",
      "Estudias",
      "Ingresos parciales",
      "Te gradúas de la universidad",
    ],
  },
  {
    id: 1,
    range: "20 — 40",
    label: "Siguientes 20 años",
    title: "Etapa Constructiva",
    color: "#B89378",
    angle: [0, 90],
    insight: "Empieza la etapa productiva — el momento de ahorrar e invertir.",
    detail:
      "Tu primer trabajo, tu primer crédito, tu primera familia. Cada decisión que tomas en esta etapa multiplica o resta a tu patrimonio futuro.",
    events: [
      "Tu primer trabajo",
      "Casa y auto",
      "Recién casado(a)",
      "Primer y segundo hijo",
      "Pago educación de hijos",
    ],
  },
  {
    id: 2,
    range: "40 — 60",
    label: "Años productivos",
    title: "Etapa Productiva",
    color: "#5B3D7E",
    angle: [90, 180],
    insight: "Pico de ingresos — el momento donde el patrimonio se construye en serio.",
    detail:
      "Tus ingresos son los más altos de tu vida. Es la última ventana real para preparar el retiro: plan de retiro, inversiones, negocio propio, fin de hipoteca.",
    events: [
      "Ascenso en tu trabajo",
      "Plan de retiro",
      "Negocio propio",
      "2da casa y/o 2do auto",
      "Viajes",
      "Fin de pago de hipoteca",
      "Inversiones",
    ],
  },
  {
    id: 3,
    range: "60 — 80+",
    label: "Últimos 20 años",
    title: "Estabilidad Financiera",
    color: "#3D1565",
    angle: [180, 270],
    insight: "Esperanza de vida en México: 65 + 15 años. ¿Tu capital financiero está listo?",
    detail:
      "El capital humano disminuye, los gastos médicos aumentan. Solo el capital financiero que construiste antes puede sostenerte aquí. Sin sueldo, con dignidad.",
    events: [
      "Vida adulta",
      "Estabilidad financiera",
      "Cuidados médicos",
      "Disfrute del patrimonio",
    ],
  },
];

export const LIFE_CYCLE_CTA = {
  title: "Conviértete en Inversionista Inteligente",
  subtitle:
    "Aprende a quitarte el dinero antes de gastártelo — el hábito que separa a quien construye patrimonio de quien lo persigue toda la vida.",
  buttonLabel: "Conoce el método",
  url: "https://www.quitameloporquemelogasto.com.mx",
};

/* -------------------- PRODUCT RECOMMENDATIONS BY AGE --------------------
 * 6 stages mapped to age ranges, each with the financial products that
 * make most sense for that period of life. Inspired by the Allianz
 * "momentos de vida" acumulación → gestión → decumulación curve.
 */
export const LIFE_RECOMMENDATIONS = [
  {
    minAge: 0,
    maxAge: 18,
    stage: "Niñez & Adolescencia",
    phase: "Acumulación temprana",
    title: "Sembrar desde el inicio",
    desc:
      "La oportunidad de empezar antes que nadie. Cada peso ahorrado en esta etapa se multiplica décadas después con interés compuesto.",
    products: ["Plan Educativo"],
  },
  {
    minAge: 19,
    maxAge: 23,
    stage: "Etapa Formativa",
    phase: "Primer paso financiero",
    title: "Primera póliza, primera inversión",
    desc:
      "Tu mejor ventaja es el tiempo. Empezar a los 22 vs. a los 32 puede duplicar tu patrimonio al retiro.",
    products: [
      "Ahorro",
      "Vida Temporal",
      "Auto",
      "Fondos Indexados",
    ],
  },
  {
    minAge: 24,
    maxAge: 39,
    stage: "Etapa Constructiva",
    phase: "Acumulación activa",
    title: "Construir con disciplina",
    desc:
      "Familia, casa, auto, créditos. Es el momento de proteger lo que estás construyendo y empezar a invertir con consistencia.",
    products: [
      "Plan de Ahorro Personal",
      "ETF's",
      "Vida",
      "Gastos Médicos Mayores",
      "Auto",
      "Residencial",
    ],
  },
  {
    minAge: 40,
    maxAge: 54,
    stage: "Etapa Productiva",
    phase: "Acumulación máxima",
    title: "Multiplicar y blindar",
    desc:
      "Ingreso pico. La última ventana real para preparar el retiro. Diversificar, optimizar fiscalmente y blindar el patrimonio.",
    products: [
      "Patrimonial",
      "PPR con beneficios fiscales y/o liquidez",
      "Vida con Ahorro",
      "Gastos Médicos Mayores",
      "Auto",
      "Residencial",
      "Responsabilidad Civil (RC)",
    ],
  },
  {
    minAge: 55,
    maxAge: 65,
    stage: "Pre-Retiro",
    phase: "Gestión",
    title: "Transición y consolidación",
    desc:
      "Empieza la decumulación. Bajar riesgo, asegurar ingresos futuros y planear la sucesión patrimonial.",
    products: [
      "PPR",
      "Elite",
      "Plan de Sucesión",
      "Vida",
      "Gastos Médicos Mayores",
      "Auto",
      "Residencial",
    ],
  },
  {
    minAge: 66,
    maxAge: 80,
    stage: "Retiro y Estabilidad",
    phase: "Decumulación",
    title: "Disfrutar lo construido",
    desc:
      "Sin sueldo, con dignidad. Tu portafolio paga tu vida. La protección médica es prioritaria; el patrimonio se transfiere ordenadamente.",
    products: [
      "Rentas Vitalicias",
      "Gastos Médicos Mayores",
      "Fideicomiso Patrimonial",
    ],
  },
];

/* -------------------- TRUST / PROCESS / TESTIMONIALS / FAQ -------------------- */
export const TRUST_POINTS = [
  {
    title: "Regulación",
    detail:
      "Trabajamos exclusivamente con instituciones reguladas en México y en sus países de origen.",
  },
  {
    title: "Autorización",
    detail:
      "Promotores autorizados Allianz México con claves directas en Skandia y Dominion Capital Strategies.",
  },
  {
    title: "Experiencia",
    detail:
      "Más de 10 años asesorando familias y empresarios en finanzas, ahorro, inversión y protección patrimonial.",
  },
  {
    title: "Independencia",
    detail:
      "Comparamos las mejores aseguradoras del país para diseñar la solución correcta — no la más conveniente para nosotros.",
  },
];

export const PROCESS_STEPS = [
  {
    n: "01",
    title: "Diagnóstico",
    text: "Escuchamos tu situación, objetivos de vida y horizonte de tiempo. Sin compromiso.",
  },
  {
    n: "02",
    title: "Estrategia",
    text: "Diseñamos una arquitectura financiera con productos de socios institucionales.",
  },
  {
    n: "03",
    title: "Implementación",
    text: "Contratamos contigo cada póliza, plan o vehículo de inversión con total transparencia.",
  },
  {
    n: "04",
    title: "Acompañamiento",
    text: "Revisiones periódicas y ajustes ante cambios de vida, mercado o regulación.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Por primera vez tuve la sensación de que alguien diseñaba mi patrimonio con la misma seriedad con la que yo construyo mi empresa.",
    author: "Cliente · Gestión Patrimonial",
  },
  {
    quote:
      "Comparar aseguradoras sola era imposible. EMB me llevó de la mano hasta tener una cobertura internacional sin sorpresas.",
    author: "Cliente · Protección y Salud",
  },
];

export const FAQS = [
  {
    q: "¿EMB Consulting Group está regulado?",
    a: "Operamos exclusivamente con instituciones financieras y aseguradoras reguladas por la CNBV, CNSF y los reguladores de cada país de origen de nuestros socios. Como firma actuamos en calidad de promotores e intermediarios autorizados.",
  },
  {
    q: "¿Cuánto cuesta la asesoría inicial?",
    a: "El diagnóstico inicial es sin costo. Solo cuando contratas un producto a través de nuestros socios institucionales generamos comisión, siempre informada con transparencia.",
  },
  {
    q: "¿Por qué trabajan con varias aseguradoras?",
    a: "Porque la mejor solución para un cliente rara vez es la misma para otro. Comparamos coberturas, costos y servicio entre Allianz, HDI, AXA, Qualitas, BUPA, Olé Life, Atlas y más para diseñar tu protección.",
  },
  {
    q: "¿Puedo invertir en moneda extranjera?",
    a: "Sí. A través de Skandia y Dominion Capital Strategies estructuramos portafolios multi-divisa e internacionales, alineados a tu perfil de riesgo y objetivos.",
  },
  {
    q: "¿Atienden a clientes fuera de Playa del Carmen?",
    a: "Sí. Nuestros 11 asesores atienden clientes en todo México de forma híbrida — sesiones presenciales y videollamadas seguras, según tu preferencia.",
  },
];

/* -------------------- METHODOLOGY (5 steps) -------------------- */
export const METHODOLOGY = [
  {
    n: "01",
    icon: "Compass",
    title: "Diagnóstico Patrimonial",
    summary: "Mapeamos tu situación real, sin atajos.",
    detail:
      "Sesión inicial confidencial y sin costo. Revisamos ingresos, egresos, deudas, activos, dependientes económicos, objetivos de vida y horizonte temporal. Sin diagnóstico claro no hay estrategia honesta.",
    deliverables: [
      "Mapa patrimonial actual",
      "Identificación de huecos críticos",
      "Objetivos cuantificados",
    ],
  },
  {
    n: "02",
    icon: "Gauge",
    title: "Perfil de Inversionista",
    summary: "Tolerancia al riesgo medida, no asumida.",
    detail:
      "Aplicamos cuestionario formal AMASFAC + entrevista estructurada. Determinamos tu tolerancia al riesgo, capacidad real de inversión y necesidad de liquidez en cada horizonte (corto, medio, largo plazo).",
    deliverables: [
      "Clasificación de perfil documentada",
      "Capacidad de inversión por horizonte",
      "Restricciones específicas",
    ],
  },
  {
    n: "03",
    icon: "Layers",
    title: "Diseño de Estrategia",
    summary: "Arquitectura financiera personalizada.",
    detail:
      "Construimos tu arquitectura financiera con instrumentos de Allianz México, Skandia y Dominion Capital Strategies. Diversificación por clase de activo, geografía y divisa, alineada estrictamente a tu perfil y objetivos. Te explicamos el porqué de cada componente.",
    deliverables: [
      "Asignación de activos sugerida",
      "Productos institucionales seleccionados",
      "Proyección a 10, 20 y 30 años",
    ],
  },
  {
    n: "04",
    icon: "FileCheck",
    title: "Implementación Transparente",
    summary: "Contratamos contigo, no por ti.",
    detail:
      "Cada póliza, plan de inversión o vehículo patrimonial se contrata directamente con la institución correspondiente, contigo presente. Te informamos las comisiones aplicables antes de firmar. Cero letras chicas, cero sorpresas.",
    deliverables: [
      "Pólizas y contratos firmados",
      "Comisiones declaradas por adelantado",
      "Documentación digital y física",
    ],
  },
  {
    n: "05",
    icon: "RefreshCw",
    title: "Acompañamiento Continuo",
    summary: "Tu plan vive contigo.",
    detail:
      "Revisiones periódicas según el portafolio (trimestrales para inversiones, semestrales para protección, anuales para planeación patrimonial). Ajustamos ante cambios de vida (matrimonio, hijos, herencia, retiro) o de mercado / regulación.",
    deliverables: [
      "Revisiones programadas",
      "Reportes ejecutivos por escrito",
      "Reajustes de estrategia ante cambios",
    ],
  },
];

/* -------------------- CLIENT PROFILES -------------------- */
export const CLIENT_PROFILES = [
  {
    icon: "Users",
    title: "Familias en construcción patrimonial",
    desc:
      "Profesionistas y matrimonios jóvenes que empiezan a ahorrar, proteger a su familia y planear la educación de sus hijos. Aquí el tiempo es la mayor ventaja competitiva.",
    tags: ["Plan educativo", "Vida temporal", "Ahorro disciplinado"],
  },
  {
    icon: "Briefcase",
    title: "Empresarios y profesionistas en pico productivo",
    desc:
      "Clientes en sus años de mayores ingresos que requieren optimización fiscal, protección integral (vida, gastos médicos, RC) y vehículos institucionales para acumular patrimonio con eficiencia.",
    tags: ["PPR con beneficios fiscales", "GMM", "Patrimonial"],
  },
  {
    icon: "Globe2",
    title: "Inversionistas con visión global",
    desc:
      "Clientes que entienden que su patrimonio no puede vivir en una sola divisa. Estructuramos portafolios multi-divisa, ETFs internacionales y vehículos en USD/EUR a través de Skandia y Dominion Capital Strategies.",
    tags: ["Multi-divisa", "ETFs internacionales", "Custodia regulada"],
  },
  {
    icon: "Landmark",
    title: "Pre-retirados y patrimonios consolidados (HNW)",
    desc:
      "Clientes con patrimonios significativos que necesitan transición a fase de gestión y decumulación, planeación sucesoria, fideicomisos y protección médica internacional para los próximos 20-30 años.",
    tags: ["Sucesión patrimonial", "Rentas vitalicias", "Salud internacional"],
  },
];

export const CLIENT_PROFILES_INTRO = {
  eyebrow: "Para quién trabajamos",
  headline: "Desde patrimonios en construcción hasta High Net Worth.",
  lead:
    "No tenemos un único cliente ideal. Tenemos cuatro arquetipos de cliente para quienes nuestra metodología demuestra mayor impacto. Si te reconoces en alguno, podemos diseñar tu plan.",
};

/* -------------------- INVESTMENT PHILOSOPHY -------------------- */
export const PHILOSOPHY = [
  {
    n: "I",
    title: "Largo plazo sobre especulación",
    body:
      "El tiempo es el mayor aliado del interés compuesto y el peor enemigo del ruido de mercado. No prometemos retornos cortoplacistas: construimos planes con horizontes de 10, 20 y 30 años. Si alguien te ofrece duplicar tu dinero en seis meses, no es un asesor financiero.",
  },
  {
    n: "II",
    title: "Diversificación multi-divisa",
    body:
      "Entre 2000 y 2024 el peso se depreció más del 130% frente al dólar. Concentrar tu patrimonio en una sola moneda no es prudencia: es exposición silenciosa. Estructuramos portafolios en MXN, USD y otras divisas según objetivos y pasivos futuros.",
  },
  {
    n: "III",
    title: "Independencia de producto",
    body:
      "Trabajamos con tres instituciones financieras (Allianz, Skandia, Dominion) y once aseguradoras (Allianz, HDI, AXA, Qualitas, BUPA, Olé Life, Atlas y más). La pregunta no es '¿qué tenemos que venderte?' sino '¿qué es lo correcto para ti?'. Si una mejor solución existe fuera de nuestra cartera, te lo decimos.",
  },
  {
    n: "IV",
    title: "Transparencia de comisiones",
    body:
      "Antes de que firmes, sabes exactamente qué comisión genera la firma con tu contratación. Sin letras chicas, sin estructuras opacas. La asesoría inicial siempre es sin costo; los ingresos de EMB provienen únicamente de comisiones declaradas por las instituciones financieras.",
  },
];

export const IMAGES = {
  heroBg:
    "https://static.prod-images.emergentagent.com/jobs/d4836b04-f8d9-4e8f-808f-9840ff61c91b/images/7cade5d8978e809af0a83c80718aa697a655be6366335eb2e54372b336c5690d.png",
  servicesBg:
    "https://static.prod-images.emergentagent.com/jobs/d4836b04-f8d9-4e8f-808f-9840ff61c91b/images/b8903c66eb34499f55d2330b5ceb428eb8dfc7a4571cd0d2f497bd234dc3ee69.png",
  // Marco S. Equis professional portrait — used in About hero and Advisors founder card
  aboutUs:
    "https://customer-assets.emergentagent.com/job_wealth-protection-mx/artifacts/zep6tch8_99d7cc71-4155-456d-a454-c3cd33181ede.JPG",
  founderPortrait:
    "https://customer-assets.emergentagent.com/job_wealth-protection-mx/artifacts/zep6tch8_99d7cc71-4155-456d-a454-c3cd33181ede.JPG",
  office:
    "https://images.unsplash.com/photo-1621831337128-35676ca30868?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHxwcmVtaXVtJTIwb2ZmaWNlJTIwYnVpbGRpbmclMjBmYWNhZGV8ZW58MHx8fHwxNzc4ODE5MzQ0fDA&ixlib=rb-4.1.0&q=85",
};
